// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SEND_REVIEW = "Odo\u0161li hodnotenie";
export const CANCEL = "Zru\u0161";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const NEW_REVIEW = "Nov\u00e9 hodnotenie";
export const REVIEW_RATING_LABEL_BUYER = "Ako si spokojn\u00e1 s pred\u00e1vaj\u00facou?";
export const REVIEW_RATING_LABEL_SELLER = "Ako si spokojn\u00e1 s kupuj\u00facou?";
export const REVIEW_RATING_UNSATISFIED = "Nie som spokojn\u00e1 - negat\u00edvne hodnotenie";
export const REVIEW_RATING_VERY_SATISFIED = "Som spokojn\u00e1 - pozit\u00edvne hodnotenie";
export const SELECT = "Vyber..";
